import numeral from "numeral"
import { numberToCurrency } from "./objectUtils"

export function onlyNumbersAsString (value: string): string {
  if(!value || value.length === 0) return ''
  return value.replace(/\D+/g, '')
}

export function numbersAndSpecialCharacters (value: string): string {
  if(!value || value.length === 0) return ''
  return value.replace(/[a-zA-Z]+/g, '')
}

export function validateEmail(email: string) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/.test(email)) {
    return true
  } else {
    return false
  }
}

export function validateEmailsByComma (emails: string) {
  const emailList = emails.split(','); 
  const validEmails: string[] = [];
  const invalidEmails: string[] = [];

  if(!emails) return {validEmails: 0, invalidEmails: 0}
  emailList.forEach((email) => {
    if(validateEmail(email.trimStart().trimEnd())) return validEmails.push(email);
    return invalidEmails.push(email);
  });

  return {validEmails: validEmails.length, invalidEmails: invalidEmails.length}
}

export const createQueryParams = (params: object) => {
  let queryParams: string[] = []
  Object.keys(params).forEach(key => {
    if(!params[key as keyof typeof params]) return 
    return queryParams.push(key + '=' + params[key as keyof typeof params])
  })

  return queryParams.join('&');
}

export const isString = (data: any): data is string => {
  return typeof data === 'string'
}

export const valueToCurrency = (value: string | number) => {
  let currency = 0
  if(isString(value)) currency = parseInt(value) / 100 || 0
  if(!isString(value)) currency = value / 100
  return numeral(currency).format('$0,0.00')
}

export const renderPercetage = (val: string | number, defaultValue: string = '') => {
  if(val || val === 0) return val + '%'
  return defaultValue
}

export const renderCurrency = (val: string | number, defaultValue: string = '') => {
  if(val || val === 0) return numberToCurrency(val)
  return defaultValue
}

